var topMostErrorPos = 0;
var elementsAddedError = [];

/**
 * Display error messages.
 */
Nette.showFormErrors = function(form, errors) {
	var messages = [];

	for (var i in errors) {
		var elem = errors[i].element,
			message = errors[i].message;

		// if (!Nette.inArray(messages, message)) {
		if (messages.indexOf(message) == -1) {
			messages.push(message);
		}

		/*
		 *  BS rozsireni
		 */
		//var $container = $(elem).closest('.validation-group');
		var container = elem.closest('.validation-group')
		var hasValiationGroup = true;
		if (!container) {
			hasValiationGroup = false;
			container = elem.closest('.form-group')
		}

		container.classList.add('has-error', 'is-invalid');
		// $container.addClass('has-error is-invalid');

		if (message && elementsAddedError.indexOf(elem.name) === -1) {
			if (!hasValiationGroup) {
				var el, addMessageAfter;
				// var inputGroup = $container.find('.input-group');
				var inputGroup = container.querySelector('.input-group');
				if (inputGroup) {
					el = addMessageAfter = inputGroup;
				} else {
					var radio = container.querySelector('.radio:last-child');
					var checkbox = container.querySelector('.form-check__input');
					var select = container.querySelector('.form-select');
					if (radio) {
						el = radio;
						addMessageAfter = container.querySelector('.form-check__label');
					} else if (checkbox) {
						el = checkbox;
						addMessageAfter = container.querySelector('.form-check__label');
					} else if (select) {
						el = addMessageAfter = select;
					} else {
						el = addMessageAfter = container.querySelector('.form-control') ? container.querySelector('.form-control') : container.querySelector('.form-input');
					}
				}

				if(el) {
					el.classList.add('form-input--invalid');
				}
				if(addMessageAfter) {
					addMessageAfter.classList.add('form-feedback', 'form-input--invalid');
					var errorMessage = document.createElement('span');
					errorMessage.classList.add('form-feedback', 'form-feedback--invalid');
					errorMessage.innerText = message;
					addMessageAfter.parentNode.insertBefore(errorMessage, addMessageAfter.nextSibling);
				}

				//$el.after('<span class="error-message help-block invalid-feedback">' + message + '</span>');
			}
			else {
				var errorMessage = document.createElement('span');
				errorMessage.classList.add('form-feedback', 'form-feedback--invalid');
				errorMessage.innerText = message;
				container.parentNode.insertBefore(errorMessage, container.nextSibling);
				//$container.append('<span class="error-message help-block invalid-feedback">' + message + '</span>');
			}

			// elementsAddedError.push(elem.name);
			//
			// if(topMostErrorPos === 0 || topMostErrorPos > $container.offset().top) {
			// 	topMostErrorPos = $container.offset().top;
			// }
			//
			// var tabPane = $container.closest('.tab-pane');
			// if (tabPane.length) {
			// 	$('.nav-tabs a[href="#' + tabPane.attr('id') + '"]').addClass('tab-has-error tab-is-invalid');
			// }
		}
	}
};

Nette.parseJSON = function(s) {
	return (s || '').substr(0, 3) === '{op'
		? eval('[' + s + ']') // backward compatibility with Nette 2.0.x
		: JSON.parse(s || '[]');
};

/**
 * Validates whole form.
 */
Nette.validateForm = function(sender) {
	elementsAddedError = [];
	var elementsToRemove = document.querySelectorAll('.form-feedback--invalid');
	for (var i = 0, len = elementsToRemove.length; i < len; i++) {
		elementsToRemove[i].parentNode.removeChild(elementsToRemove[i]);
	}
	var elementsToRemoveClass = document.querySelectorAll('.has-error, .is-invalid, .form-input--invalid');
	for (var i = 0, len = elementsToRemoveClass.length; i < len; i++) {
		elementsToRemoveClass[i].classList.remove('has-error','is-invalid','form-input--invalid');
	}
	var tabLinksToRemoveClass = document.querySelectorAll('.nav-tabs a');
	for (var i = 0, len = tabLinksToRemoveClass.length; i < len; i++) {
		tabLinksToRemoveClass[i].classList.remove('tab-has-error','tab-is-invalid');
	}
	// $('.error-message.help-block, .invalid-feedback').remove();
	// $('.form-group.has-error, .form-group.is-invalid, .form-control.is-invalid').removeClass('has-error is-invalid');
	// $('.nav-tabs a').removeClass('tab-has-error tab-is-invalid');

	var form = sender.form || sender,
		scope = false;

	Nette.formErrors = [];

	if (form['nette-submittedBy'] && form['nette-submittedBy'].getAttribute('formnovalidate') !== null) {
		var scopeArr = Nette.parseJSON(form['nette-submittedBy'].getAttribute('data-nette-validation-scope'));
		if (scopeArr.length) {
			scope = new RegExp('^(' + scopeArr.join('-|') + '-)');
		} else {
			Nette.showFormErrors(form, []);
			return true;
		}
	}

	var radios = {}, i, elem;

	for (i = 0; i < form.elements.length; i++) {
		elem = form.elements[i];

		if (elem.tagName && !(elem.tagName.toLowerCase() in {input: 1, select: 1, textarea: 1, button: 1})) {
			continue;
		} else if (elem.type === 'radio') {
			if (radios[elem.name]) {
				continue;
			}
			radios[elem.name] = true;
		}

		if ((scope && !elem.name.replace(/]\[|\[|]|$/g, '-').match(scope)) || Nette.isDisabled(elem)) {
			continue;
		}

		if (!Nette.validateControl(elem) && !Nette.formErrors.length) {
			return false;
		}
	}

	var success = !Nette.formErrors.length;
	Nette.showFormErrors(form, Nette.formErrors);

	// if(!success) {
	// 	if(topMostErrorPos > 0) {
	// 		var pos = topMostErrorPos - 25;
	// 		if (typeof $.animate === 'function') {
	// 			console.log('func');
	// 			$('html,body').animate({
	// 				scrollTop: pos + 'px'
	// 			}, 'fast');
	// 		} else {
	// 			window.scrollTo(0, pos);
	// 		}
	// 	}
	// }

	return success;
};